const ATTRIBUTES = "attributes"
const COMPLIANCES = "compliances"
const SEALS_WE_CONTRIBUTE_TO = "seals"
const PACKAGING = "packaging"

export const CERTIFICATIONS = "certifications"
export const MANUFACTURING = "manufacturing"

export const SUSTAINABILITY_ATTRIBUTES = {
  [ATTRIBUTES]: {
    biobasedPvcBioAttributed: "biobasedPvcBioAttributed",
    phthalateFreeProduct: "phthalateFreeProduct",
    phthalateFreeProductCertificateFile: "phthalateFreeProductCertificateFile",
    phthalateFreeProductCertificateFileExpires: "phthalateFreeProductCertificateFileExpires",
    phthalateFreeProductNotExpires: "phthalateFreeProductNotExpires",
    frFree: "frFree",
    frFreeCertificateFile: "frFreeCertificateFile",
    frFreeCertificateFileExpires: "frFreeCertificateFileExpires",
    frFreeNotExpires: "frFreeNotExpires",
    mpFree: "mpFree",
    mpFreeCertificateFile: "mpFreeCertificateFile",
    mpFreeCertificateFileExpires: "mpFreeCertificateFileExpires",
    mpFreeNotExpires: "mpFreeNotExpires",
    cytotoxicity: "cytotoxicity",
    cytotoxicityCertificateFile: "cytotgenericCertificateFile",
    cytotoxicityCertificateFileExpires: "cytotoxicityCertificateFileExpires",
    cytotoxicityNotExpires: "cytotoxicityNotExpires",
    skinSafeIrritation: "skinSafeIrritation",
    skinSafeIrritationCertificateFile: "skinSafeIrritationCertificateFile",
    skinSafeIrritationCertificateFileExpires: "skinSafeIrritationCertificateFileExpires",
    skinSafeIrritationNotExpires: "skinSafeIrritationNotExpires",
    skinSafeSensitization: "skinSafeSensitization",
    skinSafeSensitizationCertificateFile: "skinSafeSensitizationCertificateFile",
    skinSafeSensitizationCertificateFileExpires: "skinSafeSensitizationCertificateFileExpires",
    skinSafeSensitizationNotExpires: "skinSafeSensitizationNotExpires",
    antimicrobial: "antimicrobial",
    backingProfile: "backingProfile",
    backingProfileLogo: "backingProfileLogo",
    carbonFootprintRange: "carbonFootprintRange",
    carbonFootprintRangeNotExpires: "carbonFootprintRangeNotExpires",
    carbonFootprintRangeCertificateFile: "carbonFootprintRangeCertificateFile",
    carbonFootprintRangeCertificateFileExpires: "carbonFootprintRangeCertificateFileExpires",
    chlorineAndHalogenFree: "chlorineAndHalogenFree",
    chlorineAndHalogenFreeCertificateFile: "chlorineAndHalogenFreeCertificateFile",
    chlorineAndHalogenFreeCertificateFileExpires: "chlorineAndHalogenFreeCertificateFileExpires",
    chlorineAndHalogenFreeNotExpires: "chlorineAndHalogenFreeNotExpires",
    plasticizerFree: "plasticizerFree",
    plasticizerFreeCertificateFile: "plasticizerFreeCertificateFile",
    plasticizerFreeCertificateFileExpires: "plasticizerFreeCertificateFileExpires",
    plasticizerFreeNotExpires: "plasticizerFreeNotExpires",
    solventFree: "solventFree",
    solventFreeCertificateFile: "solventFreeCertificateFile",
    solventFreeCertificateFileExpires: "solventFreeCertificateFileExpires",
    solventFreeNotExpires: "solventFreeNotExpires",
    alternativePolymer: "alternativePolymer"
  },
  [COMPLIANCES]: {
    prop65: "prop65",
    prop65CertificateFile: "prop65CertificateFile",
    prop65CertificateFileExpires: "prop65CertificateFileExpires",
    prop65NotExpires: "prop65NotExpires",
    prop65Logo: "prop65Logo",
    rohs: "rohs",
    rohsLogo: "rohsLogo",
    rohsCertificateFile: "rohsCertificateFile",
    rohsCertificateFileExpires: "rohsCertificateFileExpires",
    rohsNotExpires: "rohsNotExpires",
    reach: "reach",
    rohsCertificateFile: "rohsCertificateFile",
    rohsCertificateFileExpires: "rohsCertificateFileExpires",
    rohsNotExpires: "rohsNotExpires",
    reachLogo: "reachLogo",
    reachCertificateFile: "reachCertificateFile",
    reachCertificateFileExpires: "reachCertificateFileExpires",
    reachNotExpires: "reachNotExpires"
  }, 
  [CERTIFICATIONS]: {
    greenguard: "greenguard",
    greenguardLogo: "greenguardLogo",
    greenguardCertificateFile: "greenguardCertificateFile",
    greenguardCertificateFileExpires: "greenguardCertificateFileExpires",
    greenguardNotExpires: "greenguardNotExpires",
    indoorAirQuality: "indoorAirQuality",
    indoorAirQualityCertificateFile: "indoorAirQualityCertificateFile",
    indoorAirQualityCertificateFileExpires: "indoorAirQualityCertificateFileExpires",
    indoorAirQualityNotExpires: "indoorAirQualityNotExpires",
    indoorAirQualityLogo: "indoorAirQualityLogo",
    globalRecycledStandard: "globalRecycledStandard",
    globalRecycledStandardLogo: "globalRecycledStandardLogo",
    globalRecycledStandardCertificateFile: "globalRecycledStandardCertificateFile",
    globalRecycledStandardCertificateFileExpires: "globalRecycledStandardCertificateFileExpires",
    aPlusEmissions: "aPlusEmissions",
    aPlusEmissionsLogo: "aPlusEmissionsLogo",
    aPlusEmissionsCertificateFile: "aPlusEmissionsCertificateFile",
    aPlusEmissionsCertificateFileExpires: "aPlusEmissionsCertificateFileExpires",
    aPlusEmissionsNotExpires: "aPlusEmissionsNotExpires",
    epd: "epd",
    epdCertificateFile: "epdCertificateFile",
    epdCertificateFileExpires: "epdCertificateFileExpires",
    epdNotExpires: "epdNotExpires",
    oekoTex: "oekoTex",
    oekoTexCertificateFile: "oekoTexCertificateFile",
    oekoTexCertificateFileExpires: "oekoTexCertificateFileExpires",
    oekoTexNotExpires: "oekoTexNotExpires",
    hpd: "hpd",
    hpdLogo: "hpdLogo",
    hpdCertificateFile: "hpdCertificateFile",
    hpdCertificateFileExpires: "hpdCertificateFileExpires",
    hpdNotExpires: "hpdNotExpires",
  },
  // This manufacturing object is necessary to add this group
  [MANUFACTURING]: {},
  [SEALS_WE_CONTRIBUTE_TO]: {
    leed: "leed",
    leedLogo: "leedLogo",
    well: "well",
    wellLogo: "wellLogo",
  },
  [PACKAGING]: {
    packagingFscLogo: "packagingFscLogo"
  }
}

